(function () {
  "use strict";

  function demoteEmptyAppHeading() {
    document.querySelectorAll("h1 .wlm-title-pnf").forEach(function (title) {
      var heading = title.closest("h1");
      if (!heading || heading.textContent.trim()) return;

      var replacement = document.createElement("div");
      Array.prototype.slice.call(heading.attributes).forEach(function (attribute) {
        replacement.setAttribute(attribute.name, attribute.value);
      });
      while (heading.firstChild) replacement.appendChild(heading.firstChild);
      heading.replaceWith(replacement);
    });
  }

  function initVisionSection(root) {
    if (!root || root.dataset.visionReady === "true") return;
    root.dataset.visionReady = "true";

    var gallery = root.querySelector("[data-vision-gallery]");
    if (gallery) {
      var track = gallery.querySelector("[data-vision-track]");
      var slides = Array.prototype.slice.call(gallery.querySelectorAll("[data-vision-slide]"));
      var thumbs = Array.prototype.slice.call(gallery.querySelectorAll("[data-vision-thumb]"));
      var previous = gallery.querySelector("[data-vision-prev]");
      var next = gallery.querySelector("[data-vision-next]");
      var activeIndex = 0;
      var scrollFrame = null;

      function normalizeIndex(index) {
        if (!slides.length) return 0;
        return (index + slides.length) % slides.length;
      }

      function setActive(index) {
        activeIndex = normalizeIndex(index);
        thumbs.forEach(function (thumb, thumbIndex) {
          var isActive = thumbIndex === activeIndex;
          thumb.classList.toggle("is-active", isActive);
          thumb.setAttribute("aria-selected", isActive ? "true" : "false");
        });
      }

      function goTo(index, behavior) {
        if (!track || !slides.length) return;
        var targetIndex = normalizeIndex(index);
        track.scrollTo({
          left: slides[targetIndex].offsetLeft,
          behavior: behavior || "smooth"
        });
        setActive(targetIndex);
      }

      thumbs.forEach(function (thumb) {
        thumb.addEventListener("click", function () {
          goTo(parseInt(thumb.getAttribute("data-vision-thumb"), 10));
        });
      });

      if (previous) {
        previous.addEventListener("click", function () {
          goTo(activeIndex - 1);
        });
      }

      if (next) {
        next.addEventListener("click", function () {
          goTo(activeIndex + 1);
        });
      }

      if (track) {
        track.addEventListener("scroll", function () {
          if (scrollFrame) window.cancelAnimationFrame(scrollFrame);
          scrollFrame = window.requestAnimationFrame(function () {
            if (!track.clientWidth) return;
            setActive(Math.round(track.scrollLeft / track.clientWidth));
          });
        }, { passive: true });

        track.addEventListener("keydown", function (event) {
          if (event.key === "ArrowLeft") {
            event.preventDefault();
            goTo(activeIndex - 1);
          }
          if (event.key === "ArrowRight") {
            event.preventDefault();
            goTo(activeIndex + 1);
          }
        });
      }

      window.addEventListener("resize", function () {
        goTo(activeIndex, "auto");
      }, { passive: true });
    }

    var form = root.querySelector(".vision-product-form");
    if (form) {
      var button = form.querySelector("[data-vision-atc]");
      var status = form.querySelector("[data-vision-form-status]");

      form.addEventListener("submit", function () {
        if (!button || button.disabled) return;
        button.classList.add("is-loading");
        button.setAttribute("aria-busy", "true");
        button.textContent = "Aggiunta in corso…";
        if (status) status.textContent = "Aggiungo Spartan Vision al carrello.";
      });
    }

    root.querySelectorAll("[data-vision-buy-link]").forEach(function (link) {
      link.addEventListener("click", function (event) {
        var selector = link.getAttribute("href");
        var target = selector ? document.querySelector(selector) : null;
        if (!target) return;
        event.preventDefault();
        target.scrollIntoView({ behavior: "smooth", block: "start" });
      });
    });
  }

  function initAllVisionSections(container) {
    var scope = container || document;
    demoteEmptyAppHeading();
    scope.querySelectorAll("[data-vision-section]").forEach(initVisionSection);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", function () {
      initAllVisionSections(document);
    });
  } else {
    initAllVisionSections(document);
  }

  document.addEventListener("shopify:section:load", function (event) {
    initAllVisionSections(event.target);
  });
})();
